import { useEffect, useState } from "react";
import CustomModal from "../../components/modal";
import Button from "../../components/button";
import TextInput from "../../components/textInput/TextInput";
import "./presence.scss";

const OOO_MESSAGE_MAX_LENGTH = 500;

const OOOMessageModal = ({ isOpen, initialMessage, toggleModal, onConfirm }) => {
    const [draft, setDraft] = useState("");

    // Reload the last-saved message every time the modal opens.
    useEffect(() => {
        if (isOpen) setDraft(initialMessage ?? "");
    }, [isOpen, initialMessage]);

    return (
        <CustomModal
            isOpen={isOpen}
            hideCloseButton={true}
            title="Out Of Office Message"
            toggleModal={toggleModal}
            disableBackdropToggle={true}
            size="small"
            classname={"zIndex9999"}
        >
            <div className="mt-4" style={{ paddingLeft: "20px", paddingRight: "20px" }}>
                <p className="font14Grey mb-3">
                    Clients and talent will see this message while you're Out Of Office.
                </p>
                <TextInput
                    placeholder="Let others know why you're out (optional)"
                    value={draft}
                    onChange={(e) => setDraft(e.target.value)}
                    maxLength={OOO_MESSAGE_MAX_LENGTH}
                    className="oooMessageInput"
                />
                <div className="d-flex justify-content-end">
                    <p className="font14Grey mb-0">
                        {draft.length}/{OOO_MESSAGE_MAX_LENGTH}
                    </p>
                </div>
                <div className="d-flex justify-content-center">
                    <div className="border-top mb-2" />
                    <div className="my-3">
                        <Button
                            label="Cancel"
                            type="button"
                            onClick={toggleModal}
                            className="btn-light mx-2"
                        />
                        <Button
                            label="Confirm"
                            type="submit"
                            className="btn-blue"
                            onClick={() => onConfirm(draft)}
                        />
                    </div>
                </div>
            </div>
        </CustomModal>
    );
};

export default OOOMessageModal;
